module.exports = __webpack_public_path__ + "8b8224b0d44fedd8e604a4f3a428ca4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Off-Black_Small_RGB.png
// module id = 111
// module chunks = 0